import React from 'react';

import { IMAGES } from '../constants';
import styles from './fableticsUpgradeCreative.scss';

const FableticsUpgradeMember = () => {
    return (
        <div
            className={styles.fableticsUpgradeCreative}
            data-testid="fabletics.upgrade-creative.member.container"
        >
            <div className={styles.textBlock}>
                <p
                    className={styles.headline}
                    data-testid="fabletics.upgrade-creative.member.headline"
                >
                    Your Tennis Passport Awaits.
                </p>
                <p
                    className={styles.subhead}
                    data-testid="fabletics.upgrade-creative.member.subhead"
                >
                    {`Sign up for Power and get `}
                    <span className={styles.emphasis} data-testid="fabletics.upgrade-creative.member.subhead-emphasis">$250 in travel value</span>
                    {' instantly.'}
                </p>
            </div>
            <div className={styles.bodyBlock}>
                <p className={styles.body} data-testid="fabletics.upgrade-creative.member.body">
                    {'Plus, '}
                    <span className={styles.emphasis} data-testid="fabletics.upgrade-creative.member.body-emphasis">
                        $1000+ in free membership, VIP prices (up to 50% off), quarterly rewards
                    </span>
                    {', and more from'}
                </p>
                <img
                    src={IMAGES.fableticsLogo}
                    alt="Fabletics"
                    className={styles.fableticsLogo}
                    data-testid="fabletics.upgrade-creative.member.fabletics-logo"
                />
            </div>
            <div className={styles.imagePanels}>
                <div
                    className={styles.imagePanel}
                    data-testid="fabletics.upgrade-creative.member.image-airport"
                >
                    <img
                        src={IMAGES.airport}
                        alt="Tennis player at airport with UTR Sports bag"
                        className={styles.imagePanelImg}
                        data-testid="fabletics.upgrade-creative.member.image-airport.img"
                    />
                </div>
                <div
                    className={styles.imagePanel}
                    data-testid="fabletics.upgrade-creative.member.image-tennis"
                >
                    <img
                        src={IMAGES.tennisWomen}
                        alt="Two tennis players in Fabletics apparel"
                        className={styles.imagePanelImg}
                        data-testid="fabletics.upgrade-creative.member.image-tennis.img"
                    />
                </div>
            </div>
            <p
                className={styles.zipCaption}
                data-testid="fabletics.upgrade-creative.member.zip-caption"
            >
                USA billing ZIP required to access Fabletics.
            </p>
        </div>
    );
};

export default FableticsUpgradeMember;
